module.exports = __webpack_public_path__ + "img/vue_logo.82b9c7a5.png";